const HamburgerIcon = ({ color = "white", width = 25.333, height = 21 }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={width} 
      height={height} 
      viewBox="0 0 25.333 21"
    >
      <g transform="translate(0 1)">
        <line 
          x2="25.333" 
          fill="none" 
          stroke={color} 
          strokeWidth="2"
        />
        <line 
          x2="25.333" 
          transform="translate(0 9.5)" 
          fill="none" 
          stroke={color} 
          strokeWidth="2"
        />
        <line 
          x2="14.25" 
          transform="translate(11.083 19)" 
          fill="none" 
          stroke={color} 
          strokeWidth="2"
        />
      </g>
    </svg>
  );
};

export default HamburgerIcon;